import { Button, ButtonProps } from '@mui/material';
import { memo, ReactNode } from 'react';

type FilterChipButtonProps = {
  isChecked: boolean;
  label: ReactNode;
  onClick: () => void;
} & Omit<ButtonProps, 'variant' | 'size' | 'sx' | 'onClick'>;

const FilterChipButton = memo(function FilterChipButton({
  isChecked,
  label,
  onClick,
  ...buttonProps
}: FilterChipButtonProps) {
  return (
    <Button
      variant={isChecked ? 'outlined' : 'soft'}
      onClick={onClick}
      size="small"
      sx={{
        backgroundColor: isChecked ? 'background.neutral' : 'background.paper',
        border: isChecked ? '1px solid' : '1px solid transparent',
        borderColor: isChecked ? 'primary.main' : 'divider',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        '&.Mui-disabled': {
          backgroundColor: isChecked ? 'background.neutral' : 'background.paper',
        },
      }}
      {...buttonProps}
    >
      {label}
    </Button>
  );
});

export default FilterChipButton;
